import "../bootstrap";
import "../bugsnag";

import { Quasar, Notify, Dialog } from "quasar";

import VueGtag from "vue-gtag";
import quasarIconSet from "quasar/icon-set/svg-mdi-v7";

import { createApp } from "vue";

import AuthLayout from "./layouts/AuthLayout.vue";
import validation from "@/_shared/mixin/validations";

import { router } from "./router"; // Adjust the path as necessary

const app = createApp(AuthLayout);

import Bugsnag from "@bugsnag/js";
const bugsnagVue = Bugsnag.getPlugin("vue");
if (bugsnagVue) app.use(bugsnagVue);

console.log("[AUTH] app is loded (this will be removed when deployed by vite)");

app.use(Quasar, {
  plugins: {
    Notify,
    Dialog,
  }, // import Quasar plugins and add here
  iconSet: quasarIconSet,
  config: {}, // quasar config see: https://quasar.dev/start/vite-plugin/
});

app.use(router);

app.use(
  VueGtag,
  {
    appName: "Auth",
    pageTrackerScreenviewEnabled: true,
    config: { id: window.GOOGLE_GA4_KEY },
  },
  router,
);
app.mixin(validation);

app.mount("#app");
